import React, {useState, useEffect} from 'react';
import ApplyLoan from '../components/ApplyLoan'
import DailyInstallments from '../components/DailyInstallments'
import Footer from '../components/Footer'
import FooterBanner from '../components/FooterBanner'
import HeaderBanner from '../components/HeaderBanner'
import HeroSection from '../components/HeroSection'
// import ReviewSection from '../components/ReviewSection'
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios'

const Home = () => {

  const [width, setWindowWidth] = useState(0);

  useEffect( () => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };

    const notify = async (number)=> {
        var data = {
            number : number
        }
        const response = await toast.promise(
            axios.post('https://sheetdb.io/api/v1/kehyvnmxhium4', data),
            {
              pending: 'Sending...',
              success: 'We will contact you soon!',
              error: 'Something went wrong!',
            },
            {
                position: toast.POSITION.TOP_CENTER,
            }
        );
        console.log(response);
    }
   
  return (
    <div>
        <HeaderBanner width={width}/>
        <HeroSection notify={notify} width={width}/>
        <ApplyLoan width={width}/>
        <DailyInstallments width={width}/>
        <FooterBanner width={width}/>
        <Footer width={width}/>
        <ToastContainer closeButton={false}/>
    </div>
  )
}

export default Home